import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import Fields from './Fields';

const DateForm = forwardRef(({entity, onSave}, ref) => {
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={entity}
      type="entity"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={onSave}
    />
  );
});

export default DateForm;
